export default __webpack_public_path__ + "static/media/client-13.f38aa6e2.png";